import styled from 'styled-components';

const StyledContent = styled.div`
  background-color: #ff6767;
  border-radius: 8px;
  margin-top: 5px;
  padding: 8px;
  display: block;
  h3 {
    font-family: 'Maison Neue';
    font-size: 16px;
    color: white;
    font-weight: 700;
    margin-bottom: 0;
    margin-top: 0;
  }
`;
export default StyledContent;
